export const ACTION_STATUS_INITIALS = {
    rotate: false,
    pan: false,
    dolly: false,
    'dolly-rotate': false,
    'dolly-pan': false,
};
export const ACTIONS_CONTINUOUS = [
    'pan',
    'rotate',
    'dolly-rotate',
    'dolly-pan',
];
export const ACTIONS_DISCRETE = ['dolly'];
